export default __webpack_public_path__ + "static/NNNittiGrotesk-TextMedium-b2a228fad257a041caf168345702f3ac.eot";